// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import './element-ui'
import eventBus from "@/units/eventBus";
import { getDeviceTypeByWidth } from "@/units/device";
// 自定义指令：关闭下拉框和多选框...的时候hover显示完整内容
import ellipsisTitle from "@/units/directive/ellipsisTitle";
import closeSelect from "@/units/directive/closeSelect";

Vue.use(ellipsisTitle);
Vue.use(closeSelect);
Vue.prototype.$bus = eventBus;

Vue.prototype.$getDeviceType = function (width) {
  return getDeviceTypeByWidth(width);
};

const deviceState = Vue.observable({
  type: getDeviceTypeByWidth(),
});

const updateGlobalDeviceType = () => {
  deviceState.type = getDeviceTypeByWidth();
};

if (typeof window !== "undefined") {
  window.addEventListener("resize", updateGlobalDeviceType);
}

Object.defineProperty(Vue.prototype, "$deviceType", {
  get() {
    return deviceState.type;
  },
});

Vue.config.productionTip = false



import '@/assets/styles/common.css';      // 公共样式

// 箭头函数
const add = (a, b) => a + b;

// Promise 对象
const promise1 = new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve(add(1, 2));
  }, 1000);
});

const promise2 = new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve(add(3, 4));
  }, 1000);
});

const promise3 = new Promise((resolve, reject) => {
  setTimeout(() => {
    resolve(add(5, 6));
  }, 1000);
});

// Promise.all([promise1, promise2, promise3]).then(values => {
//   console.log(values); // [3, 7, 11]
// });

// 实例方法：Array.prototype.includes()
// const arr = [1, 2, 3, 4, 5];
// console.log(arr.includes(3)); // true

// const root = document.getElementById('root');
// root.innerHTML = add(1, 3);


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js